export default "__VITE_ASSET__CuiA5t3E__"